import React, {Component} from 'react';
import {Select, Input, Button, message, Table, Icon} from 'antd';
import {Redirect} from 'react-router';
import utils from '../../../utils/common';
import TreeMenu from '../../../components/backEnd/treeMenu';
import StepsModel from '../../../components/backEnd/steps';

const Option = Select.Option;
let data = [];
let Nodes = [];
class SelectGoods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      goodsData: [],
      treeData: [],
      selectData: [],
      selectedRowKeys: '',
      search: {
        goods_category_id: '',
        goods_name: '',
        goods_bar_no: '',
      },
      pagination: {
        page_size: 10,
        current: 1,
        total: null,
        onChange: this.changePage
      },
      isLoading: true
    };
  }
  componentWillMount() {
    data = [];
    Nodes = [];
    if (window.common.loginOut(this)) {
      const locaParams = JSON.parse(window.localStorage.getItem('locaParams'));
      if (locaParams !== null) {
        const search = {
          goods_category_id: locaParams.goods_category_id,
          goods_name: locaParams.goods_name,
          goods_bar_no: locaParams.goods_bar_no,
        };
        this.setState({search, selectData: locaParams.selectData, selectedRowKeys: locaParams.selectedRowKeys});
      }
      this.loadList();
      // 获取商品类型
      Promise.all([window.api('goods.getcategorylist', {})]).then(res => {
        this.setState({treeData: res[0].goods_category_list});
      }).catch(error => {
        if (error.service_error_code === 'EPS000000801') {
          this.setState({redirect: true});
        }
        message.error(error.service_error_message);
      });
    } else {
      message.error('登录信息失效，请重新登录');
    }
  }
  loadList = () => {
    let params = {
      page_size: this.state.pagination.page_size,
      current_page: this.state.pagination.current,
      goods_property: 1, //只显示硬件
      is_source_cms: window.localStorage.getItem('sourceCMS') === '1' ? 1 : '',
      ...this.state.search
    };
    params = utils.dealElement(params);
    window.api('goods.getgoodslist', params).then(rs => {
      const pagination = Object.assign(this.state.pagination, {total: rs.total_result});
      this.setState({goodsData: rs.goods_list, pagination, isLoading: false});
    }).catch(error => {
      if (error.service_error_code === 'EPS000000801') {
        this.setState({redirect: true});
      }
      message.error(error.service_error_message);
      this.setState({isLoading: false});
    });
  }
  changePage = (page) => {
    page = page === 0 ? 1 : page;
    const pagination = Object.assign(this.state.pagination, {current: page});
    this.setState({pagination});
    this.loadList();
  }
  searchGoodsEvent = () => {
    this.loadList(1);
  }
  changeFormEvent = (type, text) => {
    const search = this.state.search;
    let value;
    if (text === undefined) return;
    if (type === 'goods_category_id') {
      value = text;
    } else {
      value = text.target.value;
    }
    Object.assign(search, {[type]: value});
    this.setState({search});
  }
  onSelectChange = (selectedRowKeys, selectedRows) => {
    data = data.concat(selectedRows);
    const arr = new Set(data);
    this.setState({selectedRowKeys, selectData: [...arr]});
  }
  prevToEvent = () => {
    window.history.go(-1);
  }
  nextToEvent = (type) => {
    if (this.state.selectedRowKeys.length === 0) {
      message.error('请选择商品');
      return false;
    }
    if (this.state.selectedRowKeys.length > 10) {
      message.error('最多只能选择10件商品');
      return false;
    }
    let flag = false;
    const nodeData = [];
    console.log(this.state.selectedRowKeys, this.state.selectData);
    this.state.selectedRowKeys.map(node => {
      this.state.selectData.map(item => {
        if (node === item.id) {
          nodeData.push(item);
        }
      });
    });
    nodeData.map(item => {
      if (item.goods_num === 0) {
        flag = true;
      }
    });
    if (flag) {
      message.error('请选择有库存的商品');
      flag = false;
      return false;
    }
    const selectData = nodeData;
    const params = {
      ...this.state.search,
      current_page: this.state.pagination.current,
      selectData,
      selectedRowKeys: this.state.selectedRowKeys
    };
    this.props.history.push({pathname: '/main/editgoods', state: {params, type}});
  }
  render() {
    const {
      redirect,
      goodsData,
      search,
      treeData,
      pagination,
      isLoading
    } = this.state;
    if (redirect) return (<Redirect to="/login" />);
    const columns = [
      {
        title: '商品名称',
        key: 'goods_name',
        dataIndex: 'goods_name'
      },
      {
        title: '商品单价',
        key: 'sale_price',
        dataIndex: 'sale_price',
        render: (record) => (
          <span>￥{record}</span>
        )
      },
      {
        title: '商品库存',
        key: 'goods_num',
        dataIndex: 'goods_num'
      },
      {
        title: '已售数量',
        key: 'sell_out',
        dataIndex: 'sell_out'
      }
    ];
    const rowSelection = {
      onChange: this.onSelectChange,
      selectedRowKeys: this.state.selectedRowKeys,
    };
    return (
      <div className="package-blocks package-select-goods">
        <StepsModel currentStep={0} />
        <ul className="search-items">
          <li>
            <TreeMenu selParentEvent={this.changeFormEvent.bind(this, 'goods_category_id')} parent_id={search.goods_category_id} treeData={treeData} />
          </li>
          <li><Input onChange={this.changeFormEvent.bind(this, 'goods_name')} placeholder="请输入商品名称" value={search.goods_name} /></li>
          <li><Input onChange={this.changeFormEvent.bind(this, 'goods_bar_no')} placeholder="请输入商品条形码" value={search.goods_bar_no} /></li>
          <li>
            <Button type="primary" onClick={this.searchGoodsEvent.bind(this)}>搜索</Button>
          </li>
        </ul>
        <Table
          columns={columns}
          rowSelection={rowSelection}
          dataSource={goodsData}
          pagination={pagination}
          rowKey={record => record.id}
          loading={isLoading}
        />
        <div className="g-tc-flex mt30">
          <Button onClick={this.prevToEvent.bind(this)} className="btn-secondary"> <Icon type="left" />返回</Button>
          <Button type="primary" onClick={this.nextToEvent.bind(this, 0)}>下一步<Icon type="right" /></Button>
        </div>
      </div>
    );
  }
}
export default SelectGoods;



// WEBPACK FOOTER //
// ./src/containers/backEnd/packageMangement/selectgoods.jsx